import { toastr } from "react-redux-toastr";
import { client, apiFormatter, handleErrors, stringifyQuery } from "utils/api";

export const toggleFilters = () => (dispatch) =>
  dispatch({ type: "USERS_TOGGLE_FILTERS" });

export const filterUsers = (query) => (dispatch) =>
  dispatch({ type: "USERS_SET_FILTERS_QUERY", query });

export const getUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: "USER_LOADING" });
    const { data } = await client.get(`/users/${id}?include=department`);
    dispatch({
      type: "USER_SUCCESS",
      data: apiFormatter(data),
    });
  } catch (error) {
    dispatch({ type: "USER_FAILURE" });
    toastr.error("Błąd", "Wystąpił błąd podzczas pobierania");
  }
};

export const getUsers =
  ({ page = 1, per_page = 10, ...rest }) =>
  async (dispatch, getState) => {
    try {
      const {
        status,
        filters: { query },
      } = getState().users;
      status === "invalid"
        ? dispatch({ type: "USERS_LOADING" })
        : dispatch({ type: "USERS_SEARCHING" });

      const { data } = await client.get(
        `/users?include=department&${stringifyQuery({
          ...rest,
          page,
          per_page,
          ...query,
        })}`
      );
      dispatch({
        type: "USERS_SUCCESS",
        data: apiFormatter(data),
        meta: data.meta,
      });
    } catch (error) {
      console.log(error);
      dispatch({ type: "USERS_FAILURE" });
      toastr.error("Błąd", "Wystąpił błąd podczas pobierania");
    }
  };

export const createUser = async (values) => {
  try {
    const {
      data: {
        data: { id },
      },
    } = await client.post("/users", values);

    toastr.success("Sukces", "Użytkownik został dodany");

    return id;
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd podzczas aktualizowania użytkownika");
    throw handleErrors(err.response.data.errors);
  }
};

export const updateUser = (id, values) => async (dispatch) => {
  try {
    const { data } = await client.put(`/users/${id}`, values);
    toastr.success("Sukces", "Użytkownik został zaktualizowany");
    dispatch({
      type: "USER_SUCCESS",
      data: apiFormatter(data),
    });
  } catch (error) {
    toastr.error("Błąd", "Wystąpił błąd podzczas aktualizowania użytkownika");
    throw handleErrors(err.response.data.errors);
  }
};
